<template>
	<div>
	   <el-row :gutter="20" v-loading="EditLoading">					   
			   <el-form ref="form" v-model="AdsForm"  label-width="80px">			
				  <el-col :span="6">
					 <el-form-item label="投放范围">
						<el-radio-group size="small" v-model="AdsForm.delivery_range">
						  <el-radio-button disabled label="DEFAULT">默认</el-radio-button>
						  <el-radio-button disabled label="UNION">穿山甲</el-radio-button>								  
						</el-radio-group>
					  </el-form-item>
					  <el-form-item v-if="AdsForm.delivery_range=='UNION'" label="投放形式">
						<el-radio-group size="small" v-model="AdsForm.union_video_type">
						  <el-radio-button disabled label="REWARDED_VIDEO">激励视频</el-radio-button>
						  <el-radio-button disabled label="ORIGINAL_VIDEO">原生</el-radio-button>								  
						</el-radio-group>
					  </el-form-item>
					  <el-form-item label="下载方式">
						<el-radio-group disabled size="small" v-model="AdsForm.download_type">
						  <el-radio-button  label="DOWNLOAD_URL">下载链接</el-radio-button>
						  <el-radio-button  label="EXTERNAL_URL">落地页</el-radio-button>								  
						</el-radio-group>
					  </el-form-item>					  
					  <el-form-item v-if="AdsForm.download_type=='EXTERNAL_URL'" label="链接地址">
						 <el-input disabled  size="small" v-model="AdsForm.external_url"></el-input>
					  </el-form-item>							  
					  <el-form-item v-if="AdsForm.download_type=='DOWNLOAD_URL'" label="下载地址">
						 <el-input  size="small"  disabled v-model="AdsForm.download_url"></el-input>
					  </el-form-item>
					  <el-form-item v-if="AdsForm.download_type=='DOWNLOAD_URL'" label="应用包名">
						 <el-input size="small" disabled v-model="AdsForm.package"></el-input>
					  </el-form-item>
					  <el-form-item label="转化ID">
						 <el-input size="small" disabled v-model="AdsForm.convert_id"></el-input>
					  </el-form-item>
					  <el-form-item  label="性别">
							<el-radio-group size="small" v-model="AdsForm.audience.gender">
							  <el-radio-button label="NONE">不限</el-radio-button>
							  <el-radio-button label="GENDER_MALE">男</el-radio-button>
							  <el-radio-button label="GENDER_FEMALE">女</el-radio-button>									  
							</el-radio-group>
						</el-form-item>
				  </el-col>
				  <el-col :span="10"><div class="grid-content bg-purple">	
					<el-form-item label="年龄">
							 <el-checkbox-group v-model="AdsForm.audience.age" size="mini">
								  <el-checkbox-button label="AGE_BELOW_18"><18</el-checkbox-button>
								  <el-checkbox-button label="AGE_BETWEEN_18_23">18-23</el-checkbox-button>
								  <el-checkbox-button label="AGE_BETWEEN_24_30">24-30</el-checkbox-button>
								  <el-checkbox-button label="AGE_BETWEEN_31_40">31-40</el-checkbox-button>
								  <el-checkbox-button label="AGE_BETWEEN_41_49">41-49</el-checkbox-button>
								  <el-checkbox-button label="AGE_ABOVE_50">>=50</el-checkbox-button>
							</el-checkbox-group>
					</el-form-item>
				  <el-form-item  label="定向人群">
						<el-select size="small" v-model="AdsForm.audience.retargeting_tags_include" class="custom_audience" multiple placeholder="请选择">
						  <el-option v-for="item in custom_audience"  :key="item.custom_audience_id" :label="item.name" :value="item.custom_audience_id"></el-option>
						</el-select>
				  </el-form-item>
				  <el-form-item  label="排除人群">
					<el-select size="small" v-model="AdsForm.audience.retargeting_tags_exclude" class="custom_audience" multiple placeholder="请选择">
					  <el-option v-for="item in custom_audience" :label="item.name" :key="item.custom_audience_id" :value="item.custom_audience_id"></el-option>
					</el-select>
				  </el-form-item>
					<el-form-item  label="行为兴趣">
						<el-radio-group size="small" v-model="AdsForm.ad_tag">
						  <el-radio-button label="-1">不限</el-radio-button>
						  <el-radio-button label="-2">系统推荐</el-radio-button>					  
						</el-radio-group>
					</el-form-item>
					<el-form-item  label="网络">	
					<el-checkbox-group size="small" v-model="AdsForm.audience.ac">								 
					  <el-checkbox-button label="WIFI">WIFI</el-checkbox-button>
					  <el-checkbox-button label="2G">2G</el-checkbox-button>
					  <el-checkbox-button label="3G">3G</el-checkbox-button>
					  <el-checkbox-button label="4G">4G</el-checkbox-button>								  
					</el-checkbox-group>
				  </el-form-item>							 
				  <el-form-item  label="最低系统版本" label-width="120px">
					<el-select size="small" v-model="AdsForm.version">
						<el-option v-for="item in versionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
					  </el-select>
				 </el-form-item>								
				  </div></el-col>
				 <el-col :span="8"><div class="grid-content bg-purple">
				   <el-form-item label="出价方式">
					<el-radio-group size="small" disabled v-model="AdsForm.smart_bid_type">
					  <el-radio label="SMART_BID_CUSTOM">手动</el-radio>
					  <el-radio label="SMART_BID_CONSERVATIVE">自动</el-radio>								  
					</el-radio-group>
				  </el-form-item>
				  <el-form-item v-show="AdsForm.smart_bid_type=='SMART_BID_CUSTOM'" label="目标出价">
					 <el-input size="small" style="width:60%;" v-model="AdsForm.cpa_bid">
					  <template slot="append">元</template>
					 </el-input>
				  </el-form-item>
				  <el-form-item label="投放方式">
					<el-radio-group size="small" v-model="AdsForm.flow_control_mode">
					  <el-radio-button label="FLOW_CONTROL_MODE_FAST">优先跑量</el-radio-button>
					  <el-radio-button label="FLOW_CONTROL_MODE_BALANCE">均衡投放</el-radio-button>
					  <el-radio-button label="FLOW_CONTROL_MODE_SMOOTH">优先低成本</el-radio-button>								  
					</el-radio-group>
				  </el-form-item>
				  <el-form-item label="预算">
					<el-input size="small"  placeholder="设置预算金额" v-model="AdsForm.budget" class="input-with-select">
						<el-select style="width:100px;" disabled v-model="AdsForm.budget_mode" slot="prepend" placeholder="请选择">
						  <el-option label="日预算"  value="BUDGET_MODE_DAY"></el-option>
						  <el-option label="总预算" value="BUDGET_MODE_TOTAL"></el-option>
						</el-select>									
					  </el-input>
				  </el-form-item>
				  <el-form-item label="投放时间">
					 <el-radio-group size="small" v-model="AdsForm.schedule_type">
					  <el-radio-button label="SCHEDULE_FROM_NOW">从今天起长期投放</el-radio-button>
					  <el-radio-button label="SCHEDULE_START_END">设置开始和结束时间</el-radio-button>					  
					</el-radio-group>
				  </el-form-item>
				  <el-form-item v-show="AdsForm.schedule_type=='SCHEDULE_START_END'">
					 <el-date-picker value-format="yyyy-MM-dd HH:mm" size="small" style="width:44%;" v-model="AdsForm.start_time" type="date" placeholder="开始日期"></el-date-picker>-
					 <el-date-picker value-format="yyyy-MM-dd HH:mm" size="small" style="width:44%;" v-model="AdsForm.end_time" type="date" placeholder="结束日期"></el-date-picker>								 
				  </el-form-item>
				  <el-form-item v-show="false" label="投放时段">
					 <el-input type="textarea"  v-model="AdsForm.schedule_time"></el-input>					
				  </el-form-item>
				   <el-form-item label="计划名称">
					 <el-input type="text"  v-model="AdsForm.name"></el-input>					
				  </el-form-item>
				 </div></el-col>
			  </el-form>
			   <div class="demo-drawer__footer">
				  <el-button size="small" @click="cancelOpen">取 消</el-button>
				  <el-button plain type="primary" @click="addAds" size="small">新建</el-button>
				  <el-button size="small" @click="saveEditAds" type="danger">仅修改保存</el-button>
				</div>
		  </el-row>
	</div>
</template>

<script>
	import { getDefaultDataList,savePostAds,addPostAds } from '../../../../api/api';
	
	export default {
		props:{
		 AdsForm: {
            type: Object,
			default:{}
		  }
		},
		data() {
			return {				
				versionList:[],
				EditLoading:false,
				custom_audience:[]
			}
		},
		computed:{
		   advertiser_id(){
		     return this.$store.getters.getAdvertiserId
		   }
		},
		methods: {
		  	cancelOpen(){
			 this.$emit("cancelAdsEditDrawer")
			},
			getDefaultData(){
		     let param = {
			   advertiser_id:this.advertiser_id,
			   type:1
			}
			 getDefaultDataList(param).then((res) => {
					this.versionList = res.data.versionList					
					this.convert_list = res.data.convert_list
					this.custom_audience = res.data.audience
				});
		  },
		  saveEditAds(){
		   this.EditLoading = true
		   savePostAds(this.AdsForm).then((res) => {
					this.EditLoading = false					
					if( res.code==200 )
					{
					  this.$message.success(res.message);					  
					  this.$emit("cancelAdsEditDrawer")
                      this.$emit("updateAds")					  
					}else{
					  this.$message.error(res.message);
					}
				});
		  },
		  addAds(){
		    
			addPostAds(this.AdsForm).then((res) => {					
					if( res.code==200 )
					{
					  this.$message.success(res.message);					  
					  this.$emit("cancelAdsEditDrawer")
                      this.$emit("updateAds")					  
					}else{
					  this.$message.error(res.message);
					}
				});
		  },
		  getCreative(){			  
			  let para = {
					page: this.page,
					advertiser_id: this.advertiser_id,
					page_size:this.pagesize
				};
				this.listLoading = true;
				getCreativeListPage(para).then((res) => {
					this.total = res.data.page_info.total_number;
					this.list = res.data.list;
					this.listLoading = false;
				});
			}
		},
		mounted() {	
		  this.getDefaultData()
		}
	}

</script>
<style  lang="scss">
.demo-drawer__footer{text-align:right;margin:10px;}
</style>


// WEBPACK FOOTER //
// ads.vue?d7adee6a